import BeforeUnload from './BeforeUnload';

export default BeforeUnload;